export const BUDGET_HEALTH_LABELS = {
  no_budget: 'No Budget',
  forecast_incomplete: 'Forecast Incomplete',
  under_budget: 'Under Budget',
  at_budget: 'At Budget',
  over_budget: 'Over Budget',
};

export const budgetHealthLabel = (v) => BUDGET_HEALTH_LABELS[v] || v;

export const BUDGET_HEALTH_STYLES = {
  no_budget: 'bg-gray-800 text-gray-400 border-gray-700',
  forecast_incomplete: 'bg-amber-900/30 text-amber-400 border-amber-800',
  under_budget: 'bg-green-900/40 text-green-400 border-green-800',
  at_budget: 'bg-blue-900/40 text-blue-400 border-blue-800',
  over_budget: 'bg-red-900/40 text-red-400 border-red-800',
};

export const BUDGET_HEALTH_OPTIONS = Object.entries(BUDGET_HEALTH_LABELS).map(([value, label]) => ({ value, label }));

export const bpsToPercent = (bps) => {
  if (bps === null || bps === undefined) return null;
  return `${(bps / 100).toFixed(1)}%`;
};

export const FORECAST_CATEGORY_LABELS = {
  remaining_expense_forecast_cents: 'Remaining Expenses',
  remaining_labor_forecast_cents: 'Remaining Employee Labor',
  remaining_subcontractor_forecast_cents: 'Remaining Subcontractor Cost',
  remaining_other_forecast_cents: 'Remaining Other Cost',
};
